import { render, staticRenderFns } from "./OpportunisticCustomers.vue?vue&type=template&id=179d3cf4"
import script from "./OpportunisticCustomers.vue?vue&type=script&lang=js"
export * from "./OpportunisticCustomers.vue?vue&type=script&lang=js"
import style0 from "./OpportunisticCustomers.vue?vue&type=style&index=0&id=179d3cf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports